module.exports = __webpack_public_path__ + "static/media/20201114_162549_429_IMG_0034.66df4570.jpg";